import { validate, validators } from '../utils/validation';
import buildMakeValve from './valve';
import buildMakeValveExerciseSettings from './valveExerciseSettings';
import buildMakeValveExercise from './valveExercise';
import buildMakeTorqueLog from './torqueLog';
import buildMakeCompany from './company';
import buildMakeCompanyLogo from './companyLogo';
import buildDefaultMakeValveExerciseSettings from './defaultValveExerciseSettings';
import buildMakeHydrant from './hydrant';
import buildMakeFireFlowTest from './fireFlowTest';
import buildMakeFireFlowTestHydrant from './fireFlowTestHydrant';
import buildMakeHydrantManufacturer from './hydrantManufacturer';
import buildMakeHydrantModel from './hydrantModel';
import buildMakeHydrantImage from './hydrantImage';
import buildMakeHydrantExerciseSettings from './hydrantExerciseSettings';
import buildMakeDefaultHydrantExerciseSettings from './defaultHydrantExerciseSettings';
import buildMakeHydrantExercise from './hydrantExercise';
import buildMakeHydrantTorqueLog from './hydrantTorqueLog';
import buildMakeFlowDevice from './flowDevice';
import buildMakeFlowHydrantReport from './fireFlowReport/flowHydrantReport';
import buildMakePSIGPMReport from './fireFlowReport/psiGPMReport';
import buildMakeFireFlowReport from './fireFlowReport';
import buildMakeFlowDeviceKFactor from './flowDeviceKFactor';
import buildMakeFlowChart from './flowChart';
import buildMakeHydrantFlush from './hydrantFlush';
import buildMakeHydrantDeficiency from './hydrantDeficiency';
import buildMakeValveDeficiency from './valveDeficiency';

const makeDefaultValveExerciseSettings = buildDefaultMakeValveExerciseSettings({ validate, validators });
const makeCompany = buildMakeCompany({ validate, validators, makeDefaultValveExerciseSettings });
const makeCompanyLogo = buildMakeCompanyLogo({ validate, validators });
const makeValve = buildMakeValve({ validate, validators });
const makeValveExerciseSettings = buildMakeValveExerciseSettings({ validate, validators });
const makeTorqueLog = buildMakeTorqueLog({ validate, validators });
const makeValveExercise = buildMakeValveExercise({ validate, validators, makeTorqueLog });
const makeHydrant = buildMakeHydrant({ validate, validators });
const makeFireFlowTest = buildMakeFireFlowTest({ validate, validators });
const makeFireFlowTestHydrant = buildMakeFireFlowTestHydrant({ validate, validators, makeFireFlowTest });
const makeHydrantManufacturer = buildMakeHydrantManufacturer({ validate, validators });
const makeHydrantModel = buildMakeHydrantModel({ validate, validators });
const makeHydrantImage = buildMakeHydrantImage({ validate, validators });
const makeHydrantExerciseSettings = buildMakeHydrantExerciseSettings({ validate, validators });
const makeDefaultHydrantExerciseSettings = buildMakeDefaultHydrantExerciseSettings({ validate, validators });
const makeHydrantTorqueLog = buildMakeHydrantTorqueLog({ validate, validators });
const makeHydrantExercise = buildMakeHydrantExercise({ validate, validators, makeHydrantTorqueLog });
const makeFlowDeviceKFactor = buildMakeFlowDeviceKFactor({ validate, validators });
const makeFlowDevice = buildMakeFlowDevice({ validate, validators, makeFlowDeviceKFactor });
const makeFlowChart = buildMakeFlowChart({ validate, validators });

const makeFlowHydrantReport = buildMakeFlowHydrantReport();
const makePSIGPMReport = buildMakePSIGPMReport();
const makeFireFlowReport = buildMakeFireFlowReport({ makeFlowHydrantReport, makePSIGPMReport });

const makeHydrantDeficiency = buildMakeHydrantDeficiency({ validate, validators });
const makeValveDeficiency = buildMakeValveDeficiency({ validate, validators });
const makeHydrantFlush = buildMakeHydrantFlush({ validate, validators, makeFlowDevice, makeHydrant });

export {
  makeCompany,
  makeCompanyLogo,
  makeValve,
  makeDefaultValveExerciseSettings,
  makeValveExerciseSettings,
  makeValveExercise,
  makeTorqueLog,
  makeHydrant,
  makeFireFlowTest,
  makeFireFlowTestHydrant,
  makeHydrantManufacturer,
  makeHydrantModel,
  makeHydrantImage,
  makeHydrantExerciseSettings,
  makeDefaultHydrantExerciseSettings,
  makeHydrantExercise,
  makeHydrantTorqueLog,
  makeFlowDeviceKFactor,
  makeFlowDevice,
  makeFlowChart,
  makeFireFlowReport,
  makeHydrantDeficiency,
  makeValveDeficiency,
  makeHydrantFlush
};
